import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How does the mobile barber service work?",
    answer:
      "Once you become a member, we assign you a dedicated barber. They arrive at your chosen location (home, office, gym) at your scheduled time with all professional equipment. Sessions typically take 30-45 minutes.",
  },
  {
    question: "What areas do you serve?",
    answer:
      "We currently serve the entire San Francisco Bay Area including San Francisco, Oakland, Berkeley, San Jose, Palo Alto, and surrounding cities. If you're unsure, enter your zip code when booking and we'll confirm.",
  },
  {
    question: "Can I choose my barber?",
    answer:
      "Absolutely. We match you with a barber based on your style preferences and schedule. Once matched, you'll have the same barber for every visit to ensure consistency.",
  },
  {
    question: "What if I need to reschedule?",
    answer:
      "Life happens. You can reschedule appointments up to 4 hours before your scheduled time at no charge through text or our booking system.",
  },
  {
    question: "What's included in each visit?",
    answer:
      "Every visit includes a precision haircut (fade, taper, or classic style), lineup, beard trim, hot towel finish, and premium styling products. Members also receive complimentary grooming products quarterly.",
  },
  {
    question: "Is there a contract or commitment?",
    answer:
      "No contracts. Your membership is month-to-month and you can cancel anytime. We're confident you'll love the service.",
  },
  {
    question: "How do I cancel my membership?",
    answer:
      "You can cancel anytime by texting your barber or emailing us. Your membership stays active until the end of your current billing cycle.",
  },
  {
    question: "What happens on my first visit?",
    answer:
      "Your first visit includes a consultation where your barber learns your preferred style, hair type, and any specific requests. This ensures every cut after is exactly what you want.",
  },
];

export default function FAQSection() {
  return (
    <section data-testid="faq-section" className="relative py-24 md:py-32 bg-[#0A0A0B]">
      <div className="px-6 md:px-12 lg:px-24 max-w-3xl">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-[#C5A059]" />
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C5A059]">
              FAQ
            </span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-[#F3F4F6]">
            Common questions
          </h2>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-2">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-white/10 bg-[#141416] rounded-md px-6 border"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-[#F3F4F6] text-sm font-medium hover:text-[#C5A059] hover:no-underline py-5"
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[#A1A1AA] text-sm leading-relaxed font-light pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
